import { currency } from 'src/util/formatters';
import moment from 'moment';

export const toPrettyAmount = (amount: number) => currency(amount);

export const getPrettyDate = () => moment().format('L');

export const last4AccountNumber = (accountNumber: string) =>
    accountNumber.length > 0 ? accountNumber.substr(accountNumber.length - 4) : '';

export const getLimitText = (isInvoicePayment: boolean, amount: number): string => {
    return isInvoicePayment
        ? `ACH Payments are limited to ${toPrettyAmount(
              amount
          )}. The amount you've selected to pay is greater than this amount.`
        : `ACH Payments are limited to ${toPrettyAmount(
              amount
          )} per transaction. The amount you've selected to pay is greater than this amount. Please go back and select individual invoices to pay or choose a different payment option.`;
};
